import React from "react";

export default ({block}) => {
    return (
        <section className={"page-block"}>
            <pre>{JSON.stringify(block, null, 2)}</pre>
        </section>
    );
}
